<template>
	<v-container fill-height fluid>
		<v-row class="justify-space-between">
			<v-col md="8" cols="12">
				<div class="d-flex flex-wrap justify-md-start justify-center align-center">
					<div cols="auto">
						<v-img
							:src="fileLogo"
							width="200px"
							lazy-src="@/assets/placeholder-image.png"
						/>
					</div>
					<div class="d-flex flex-column flex-wrap ms-md-10">
						<!-- company name -->
						<div class="text-h6 mb-2 primary--text">
							{{currentFinancialFile.company_name}}
						</div>

						<!-- cashbox -->
						<div class="mb-3">
							<span class="secondary--text text-body-2">
								{{$t('Home.financial-file-fund')}}:
							</span>
							<span class="primary--text">
								{{box_account_info ? box_account_info : $t('Home.undefined')}}
							</span>
						</div>

						<!-- file state -->
						<div class="mb-3">
							<span class="econdary--text text-body-2">
								{{$t('Home.file-state')}}:
							</span>
							<span class="primary--text">
								{{file_status}}
								<v-icon
									class="ms-1 pb-1"
									color="primary"
									size="20"
								>{{file_is_locked ? 'mdi-lock-outline': 'mdi-lock-open-variant'}}</v-icon>
							</span>
						</div>

						<!-- posted files -->
						<div>
							<router-link
								:to="{name: 'journals'}"
								class="secondary--text text-decoration-none"
							>
								<div class="mb-2">
									<span class="text-body-2">{{$t('Home.total-bonds')}}:</span>
									<span class="primary--text mx-2">{{num_of_total_bonds}}</span>
									 
									<span class="text-body-2">({{bond_posting_ratio_tooltip}})</span>
								</div>
								<div class="d-flex align-center">
									<span class="primary--text me-2">
										{{bond_posting_ratio.toFixed(2) +'%'}}
									</span>
									<v-progress-linear
										color="success-color lighten-1"
										rounded
										height="5"
										:value="bond_posting_ratio"
										:style="{ maxWidth: '180px' }"
									></v-progress-linear>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</v-col>

			<!-- weather  -->
			<v-col md="4" cols="12">
				<vue-weather
					id="weather"
					:api-key="open_weather_map_api_key"
					:latitude="latitude"
					:longitude="longitude"
					:bar-color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
					:text-color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
					:language="lang"
					units="uk"
					ref="weather"
				>
					<template v-if="location.address" v-slot:title>
						{{ `Weather for ${location.address.country}, ${location.address.city}` }}
					</template>
				</vue-weather>
			</v-col>
		</v-row>

		<v-bottom-navigation
			app
			height="26"
			class="evaluation-0"
		>
			<v-row align="center" justify="center" dir="ltr" style="font-size: 12px">
				<span>Powered by</span>
				<span class="orange--text mx-1">BEETRONIX</span>
				<span>| Emerald {{settings.SYSTEM_VERSION}}</span>
			</v-row>
		</v-bottom-navigation>
	</v-container>
</template>
<script>
import { mapState } from "vuex";
import * as settings from "../../settings/index.js";
// import store from "../../store/index.js";
import i18n from "../../i18n/i18n"
import VueWeather from "vue-weather-widget";
export default {
	components: {
    	VueWeather,
    },
	data: () => {
		return {
			settings: settings,

			// location and weather
			open_weather_map_api_key: '5796abbde9106b7da4febfae8c44c232', // For more info: https://github.com/dipu-bd/vue-weather-widget
			gettingLocation: false,
			errorStr: null,

			// location coordinates
			latitude: '36.21423656415479',
			longitude: '37.137632749490834',
		};
    },
    
	computed: {
		...mapState("configs", ["configs"]),
		...mapState("weather", ["location"]),
		...mapState({
			currentFinancialFile: state => state.financialFiles.current_financial_file
		}),
		num_of_total_bonds() {
			return this.configs?.num_of_total_bonds;
		},
		bond_posting_ratio_tooltip() {
			return this.configs?.num_of_not_posted_bonds
				? ` ${this.$t('Home.not-posted')}: ${this.configs.num_of_not_posted_bonds}`
				: this.$t('Home.all-posted-bonds');
		},
		bond_posting_ratio() {
			return this.num_of_total_bonds
				? 100 - (this.configs.num_of_not_posted_bonds * 100) / this.num_of_total_bonds
				: 100;
		},
		bond_posting_ratio_caption() {
			return `${this.configs?.num_of_not_posted_bonds}/${this.num_of_total_bonds}`;
		},
		file_is_locked() {
			return this.configs?.financial_file?.is_locked;
		},
		file_status() {
			return this.file_is_locked ? this.$t('Home.locked') : this.$t('Home.unlocked');
		},
		box_account() {
			return this.configs?.accounts?.find(c => c.is_box);
		},
		box_account_info() {
			return this.box_account
				? this.box_account.accounting_no + "-" + this.box_account.name
				: "";
		},
		fileLogo() {
			return ( 
				this.currentFinancialFile.company_logo_file
					? (
						axios.defaults.baseURL.replace("/api/", "") +
						"/Content/FinancialFiles/Logos/" +
						this.currentFinancialFile.company_logo_file
					)
					: require('@/assets/Emerald.png')
			);
		},
		lang() { 
			return i18n.locale
		},
	},

	methods: {
		getLocationCoords() {
			this.gettingLocation = true;
			// get position
			navigator.geolocation.getCurrentPosition(pos => {
				this.gettingLocation = false;
				this.latitude = pos?.coords?.latitude?.toString();
				this.longitude = pos?.coords?.longitude?.toString();

				// https://www.geeksforgeeks.org/how-to-get-city-name-by-using-geolocation/
				this.$store.dispatch('weather/getLocation', { lat: this.latitude, lon: this.longitude })
			}, err => {
				this.gettingLocation = false;
				this.errorStr = err.message;
			})
		}
	},

	created() {
		if (!Object.keys(this.configs).length) this.$router.go(0);

		// get location for weather
		if('geolocation' in navigator) {
			navigator.permissions.query({ name: 'geolocation' }).then(res => {
				res.onchange = () => {
					if (res.state === 'granted') {
						this.getLocationCoords();
					}
				};
				
				if (res.state === 'granted') {
					this.getLocationCoords();
				} else {
					this.$store.dispatch('weather/getLocation', { lat: this.latitude, lon: this.longitude })
				}
			})
			
			return;
		} else {
			this.errorStr = 'Geolocation is not available.';
		}
	},
	/*
	async beforeRouteEnter(to, from, next) {
        let promises = [];
     
		let object = store.state.configs.configs;
		if (Object.keys(object).length == 0)
			promises.push(store.dispatch("configs/fetchAll"));

		if (promises.length) await Promise.all(promises);

		next();
	}
	*/
};
</script>
<style lang="scss">
#weather {
	.vww {
		&__header {
			text-align: start;
		}

		@media screen and (min-width: 960px) {
			&__content {
				flex-direction: column;
				height: 450px;
			}
			&__daily {
				width: 100%;
			}
		}
	}
}
.container.fill-height {
	align-items: unset;
	display: flex;
	flex-wrap: wrap;
}
</style>
